<template>
  <v-container
    fluid
    style="background-color: #40A0ED"
    fill-height
    class="d-flex flex-column justify-center"
  >

  <div class="DeleteContainer">
    <p>
      Esto eliminará tu cuenta de nuestro sistema, se revocarán los permisos
      actuales y no podrás acceder a la aplicación región conectada. Por favor
      confirma que deseas eliminar tu cuenta escribiendo "eliminar mi cuenta" en
      el siguiente cuadro de texto.
    </p>
            <v-text-field
            v-model="DeleteValid"
            solo
            placeholder="eliminar mi cuenta"
          ></v-text-field>
    <v-btn :disabled="disable" color="error" @click="deleteAcc">eliminar cuenta</v-btn>
  </div>

  <!-- Modal Cuenta eliminada -->
    <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
    <v-card style="height: 150px; display:flex; justify-content: center; text-align:center;align-items:center;">
        <v-card-text>
            Tu cuenta ha sido eliminada
        </v-card-text>
    </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import { deleteAccount } from '@/helpers/api/user.js'

export default {
  data() {
    return {
        DeleteValid: '',
        dialog: false
    };
  },
  computed: {
    disable() {
        return this.DeleteValid !== 'eliminar mi cuenta' ? true : false;
    }
  },
  methods: {
    deleteAcc() {
        deleteAccount().then((res)=> {
            console.log(res);
            this.dialog = true;
            setTimeout(() => {
                this.dialog = false;
                localStorage.removeItem('userToken')
                window.location.reload()
            }, 2000);
        })
    },
    mounted() {
    const token = localStorage.getItem("userToken");
    !token && this.$router.push({
        path: "/login",
        query: { redirect_to: this.$route.path },
      });
  },
  },
};
</script>

<style lang="scss" scoped>
.DeleteContainer {
    max-width: 500px;
    text-align: justify;
    background-color: #007BED;
    border-radius: 15px;
    padding: 16px;
    color: #fff;
}
</style>
